/** The answer box beside a closed question's outcomes on the timeline: its width and its gap. */
export const ANSWER_BOX_W = 380;
export const ANSWER_BOX_GAP = 20;
/** The narrowest the box gets on a narrow timeline before it moves over the marker instead. */
export const ANSWER_BOX_MIN_W = 280;
